const step = state => state.ui.stepBar.step

export { step }
